module.exports = __webpack_public_path__ + "img/profesor_2.2cd677ef.webp";